import { render, staticRenderFns } from "./carouselProduct.vue?vue&type=template&id=165de2ce&"
import script from "./carouselProduct.vue.ts?vue&type=script&lang=ts&"
export * from "./carouselProduct.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports